@if (this.isAllowed) {
  <div
    class="d-flex align-items-center justify-content-center h-100 w-100 flex-column"
    >
    <i class="ri-time-line ri-10x"></i>
    <h3>{{botConfig.name}}</h3>
    <div i18n="@@instant-access-forwarding">Du wirst gleich weitergeleitet…</div>
  </div>
} @else {
  <div class="d-flex h-100 w-100 align-items-center justify-content-center flex-column">
    <h1 i18n="@@bot-not-found">
      Dieser Bot ist nicht verfügbar. Er ist entweder nicht öffentlich oder existiert nicht mehr.
    </h1>
    <span i18n="@@bot-not-found-hint">
      Falls das ein Fehler ist, wende dich an den Bot-Besitzer.
    </span>
  </div>
}

